<template>
  <zm-button size='large' round type='primary' @click='goToHDPage'> {{ $t('billing.success.get_started') }}</zm-button>
</template>
<script>
import { translateToEn } from '@/plugins/i18n';
import { navigateParentWindowTo, sendLoginMessageToClient } from '@/utils/modal-utils.js';
import modalMixin from '@/views/modal/modal-mx.js';
import { generateGAbizInfo } from '@/views/checkout/utils';
export default {
  mixins: [modalMixin],
  methods: {
    goToHDPage() {
      this.$tracking.buyInteractionWithBizInfo('purchase confirmation', translateToEn('billing.success.get_started'),...generateGAbizInfo());
      if (this.isFreeTrialInClientModal) {
        // send login message to client
        sendLoginMessageToClient();
      } else if (this.$context.is.modal) {
        navigateParentWindowTo('/myhome');
      } else {
        window.location.href = '/myhome';
      }
    },
  },
}
</script>
